import React from 'react';
import { ErrorContainer } from './Error.styles';

export const Error = () => (
  <ErrorContainer>
    Ooops! There was a problem building the chart...
    <div className="subtitle">
      <em>Are you playing with the url?</em>
      {' '}
      😏
    </div>
  </ErrorContainer>
);
